import { useMutation } from '@tanstack/react-query';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

interface UploadAttachmentActionPlanParams {
	organization_id: string;
	company_id: string;
	size: number;
	action_plan_id?: string;
	content_type: string;
	file_name: string;
}

const Service = Resolution886ReportService.getInstance();

export function useUploadAttachmentActionPlan() {
	return useMutation({
		mutationFn: (params: UploadAttachmentActionPlanParams) => Service.uploadAttachment(params)
	});
}
